import { Outlet } from "react-router-dom";

const EmployeesParentPage = () => {
    return <Outlet />
}
export default EmployeesParentPage;